export default __webpack_public_path__ + "static/media/logo.0dcef847.svg";